import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import OperatorInput from '../OperatorInput'
import useSearchForm from '../../SearchForm/SearchFormHook'
import '../Custom.css'
import FormSubmitButton from '../FormSubmitButton'
import FormHeading from '../FormHeading'

export default function JobsiteMultiSearchForm() {
  console.log('JobsiteMultiSearchForm rendered')

  const initialInputs = []
  for (let j = 0; j < 15; j++) {
    const value = {
      operator: 'C',
      company: '',
      location: '',
    }
    initialInputs.push(value)
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useSearchForm(initialInputs, submitSearch)

  async function submitSearch() {
    console.log('JobsiteMultiSearchForm.submitSearch', inputs)
    const newInputs = []
    for (let input of inputs) {
      if (input.company.length > 0 || input.location.length > 0) {
        newInputs.push(input)
      }
    }
    const url = `/custom/fwcontracts.jobsite_multi_search?inputs=${JSON.stringify(newInputs)}`
    navigate(url)
  }

  const rows = []
  for (var i = 0; i < 15; i++) {
    const row =
      <tr key={i}>
        <td style={{ verticalAlign: 'middle' }}><b>Company/Site/Vessel</b></td>
        <td><OperatorInput index={i} handleChange={handleInputChange} /> </td>
        <td><Input size="30" key={i} index={i} name="company" onChange={handleInputChange} /></td>
        <td style={{ verticalAlign: 'middle' }}><b>Location</b></td>
        <td><Input size="50" key={i} index={i} name="location" onChange={handleInputChange} /></td>
      </tr>
    rows.push(row)
  }
  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit}>
        <FormSubmitButton label="Search" />
        <div>
          <Table bordered className="custom-table  custom-form-table">
            <FormHeading headingText='Jobsite References Multiple Search' colSpan='5' />
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Search" />
      </form>
    </div>
  )
}